import { Box, Typography } from "@mui/material";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

export const PageHeader = ({ title, subtitle }: PageHeaderProps) => {
  return (
    <Box sx={{ mb: 5, mt: 2 }}>
      <Typography
        variant="h4"
        sx={{
          color: "#00f2ff",
          fontFamily: "'Syncopate', sans-serif",
          fontWeight: 700,
          letterSpacing: "4px",
          textShadow: "0 0 10px rgba(0, 242, 255, 0.3)",
          mb: 1,
        }}
      >
        {title.toUpperCase()}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          sx={{
            color: "rgba(224, 250, 255, 0.5)",
            fontFamily: "'Orbitron', sans-serif",
            letterSpacing: "1px",
            fontSize: "0.75rem",
          }}
        >
          {`// ${subtitle.toUpperCase()}`}
        </Typography>
      )}
      <Box
        sx={{
          width: "100%",
          height: "1px",
          background: "linear-gradient(90deg, #00f2ff 0%, transparent 100%)",
          mt: 2,
          opacity: 0.3,
        }}
      />
    </Box>
  );
};
